export default __webpack_public_path__ + "static/media/featured3.0a9785a7.jpg";